import React from 'react';


import {Grid} from "@material-ui/core";
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import {SendReportUtils} from "../../../../SendReportUtils";
import PageLoadingIndicator from "../../../../../RiskProfiling/components/PageLoadingIndicator";

import {axiosInstance} from "../../../../../../utils/api";
import ProtocolPreview from "../../../../../RiskProfiling/components/ProtocolPreview/ProtocolPreview";


const PDFSettingsPreview = (props) => {
  const {
    reportSettings,
    pageWidth,
  } = props;

  const [loading, setLoading] = React.useState(true);
  const [content, setContent] = React.useState(null);

  React.useEffect(() => {
    if (reportSettings && !content){
      // fetch PDF
      const config = SendReportUtils.getDownloadRequestConfig();
      try {
        setLoading(true);

        axiosInstance.post('/reports/broker/groups-preview/', {
          'group_id': reportSettings.id,
          'is_auto_report': reportSettings.is_auto_report || false,
        }, config).then((response) => {
          setLoading(false);
          setContent(response.data);
        }).catch(error => {
          setLoading(false);
          setContent(null);
        });
      } catch (error) {
        setLoading(false);
        setContent(null);
      }
    }
  }, [reportSettings]);

  return (
    <Grid container>
      <Grid item xs={12} style={{minHeight: 300, textAlign: 'center'}}>
        {loading ? <PageLoadingIndicator /> : !!content ? (
          <ProtocolPreview content={content} width={pageWidth} height={'auto'} />
        ) : <ErrorIcon />
        }
      </Grid>
    </Grid>
  )
};

export default PDFSettingsPreview;